import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { hashPassword } from './utils/hashPassword';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Link,
  TextField,
  Typography,
  Divider,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import GoogleIcon from '@mui/icons-material/Google';
import FacebookIcon from '@mui/icons-material/Facebook';

const SignIn: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const { signIn } = useAuth();

  const handleSignIn = async () => {
    if (!email.trim() || !password.trim()) {
      alert('メールアドレスとパスワードを入力してください。');
      return;
    }

    const saved = localStorage.getItem('user-list');
    const userList = saved ? JSON.parse(saved) : [];
    const passwordHash = await hashPassword(password);

    const foundUser = userList.find(
      (user: any) => user.email === email && user.passwordHash === passwordHash
    );

    if (foundUser) {
      signIn({ id: foundUser.id, name: foundUser.name, email: foundUser.email });
      navigate('/');
    } else {
      alert('メールアドレスまたはパスワードが正しくありません。');
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, minHeight: '100vh' }}>
      {/* 左: サービス紹介 */}
      <Box
        sx={{
          flex: 1,
          backgroundColor: '#f5faff',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          px: 6,
          py: 8,
        }}
      >
        <Typography variant="h4" fontWeight="bold" color="primary" gutterBottom>
          Magic Scroll
        </Typography>

        <Box mt={2}>
          <Typography variant="h6" gutterBottom>⚙️ Adaptable performance</Typography>
          <Typography variant="body1" color="text.secondary" mb={3}>
            Our product effortlessly adjusts to your needs, boosting efficiency and simplifying your tasks.
          </Typography>

          <Typography variant="h6" gutterBottom>🛠️ Built to last</Typography>
          <Typography variant="body1" color="text.secondary" mb={3}>
            Experience unmatched durability that goes above and beyond with lasting investment.
          </Typography>

          <Typography variant="h6" gutterBottom>👍 Great user experience</Typography>
          <Typography variant="body1" color="text.secondary" mb={3}>
            Intuitive and easy-to-use interface that fits seamlessly into your routine.
          </Typography>

          <Typography variant="h6" gutterBottom>✨ Innovative functionality</Typography>
          <Typography variant="body1" color="text.secondary">
            Stay ahead with features that address your evolving needs better than the rest.
          </Typography>
        </Box>
      </Box>

      {/* 右: Material Design風ログインUI */}
      <Box
  sx={{
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    px: 4,
    py: 6,
  }}
>
  <Card elevation={6} sx={{ width: '100%', maxWidth: 400, p: 3, borderRadius: 3 }}>
    <Box display="flex" flexDirection="column" alignItems="center">
      <Avatar sx={{ bgcolor: 'primary.main', mb: 1 }}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography component="h1" variant="h5" mb={2}>
        ログイン
      </Typography>
    </Box>

    <CardContent>
      <TextField
        fullWidth
        label="メールアドレス"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        margin="normal"
        autoComplete="email"
        required
      />
      <TextField
        fullWidth
        label="パスワード"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        margin="normal"
        autoComplete="current-password"
        required
      />
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <FormControlLabel control={<Checkbox />} label="ログイン状態を保持" />
        <Link href="#" variant="body2">パスワードをお忘れですか？</Link>
      </Box>

      <Button
        fullWidth
        variant="contained"
        color="primary"
        onClick={handleSignIn}
        sx={{ mt: 2, borderRadius: 2 }}
      >
        ログインする
      </Button>

      <Typography align="center" mt={2}>
        アカウントをお持ちでないですか？{' '}
        <Link component="button" onClick={() => navigate('/signup')}>新規登録</Link>
      </Typography>

      <Divider sx={{ my: 2 }}>または</Divider>

      <Button fullWidth variant="outlined" startIcon={<GoogleIcon />} sx={{ mb: 1 }}>
        Googleでログイン
      </Button>
      <Button fullWidth variant="outlined" startIcon={<FacebookIcon />}>
        Facebookでログイン
      </Button>
    </CardContent>
  </Card>
</Box>
    </Box>
  );
};

export default SignIn;
